import axios from "axios";

const URL = "https://api-blog-bsq7.onrender.com";

const api = axios.create({
  baseURL: URL,
  timeout: 5000,
});



export default api;